import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {
    Allegato,
    fetchAllegati,
} from "./allegatiSlice";
import Card from "@mui/material/Card";
import {theme} from "../theme";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";

interface AllegatiPreviewProps {
    previsione_id?: number | null;
    light?: boolean;
    color?: string;
}

const AllegatiPreview = ({
                             previsione_id,
                             light = false,
                             color = theme.palette.divider
                         }: AllegatiPreviewProps) => {
        const dispatch = useAppDispatch();

        useEffect(() => {
            dispatch(
                fetchAllegati({
                    previsione_id: previsione_id,
                    // preview: true
                })
            );
        }, [previsione_id]);

        const allegati: Allegato[] | undefined = useSelector<
            RootState,
            Allegato[] | undefined
        >((state) =>
            state.allegati.allegati.results.filter((allegato   => allegato.previsione === previsione_id)
        ))


        return (
            <Card sx={{mb: 2}} key={`allegati_${previsione_id}`}>
                {allegati?.filter(a => a.preview == true).length == 0 &&
                    <Alert severity="warning">Nessuna immagine di Preview trovata</Alert>
                }

                {allegati?.filter(a => a.preview == true).map((immagine) =>
                    <CardMedia
                        component="img"
                        key={`immagine-${immagine.id}`}

                        image={immagine.file}
                        title={immagine.autore}
                    />
                )}
            </Card>
        )
    }
;

export default AllegatiPreview;
